import { render, staticRenderFns } from "./DetailNext.vue?vue&type=template&id=7244f306&scoped=true"
import script from "./DetailNext.vue?vue&type=script&lang=js"
export * from "./DetailNext.vue?vue&type=script&lang=js"
import style0 from "./DetailNext.vue?vue&type=style&index=0&id=7244f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244f306",
  null
  
)

export default component.exports